import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Redesign from './components/Redesign';

const App = () => (
  <Router>
    <Routes>
      <Route path="/" element={<Redesign />} />
      {/* Catch any unknown path. */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </Router>
)

export default App
